import { inherits as _inherits, createClass as _createClass, toConsumableArray as _toConsumableArray, defineProperty as _defineProperty, classCallCheck as _classCallCheck, callSuper as _callSuper, objectSpread2 as _objectSpread2, slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';
import deepmerge from 'deepmerge';
import get from 'lodash/get.js';
import set from 'lodash/set.js';
import cloneDeep from 'lodash/cloneDeep.js';
import { i18n } from '../../i18n/translate.js';
import { Row } from '../Row.js';
import { FAIcon } from '../fa-icon/component.js';

var MultiRowFieldGroup = /*#__PURE__*/function (_React$Component) {
  function MultiRowFieldGroup(_props) {
    var _this;

    _classCallCheck(this, MultiRowFieldGroup);

    _this = _callSuper(this, MultiRowFieldGroup, [_props]);

    _defineProperty(_this, "delete", function (index) {
      return function () {
        if (!_this.canDeleteRow(index)) {
          return;
        }

        var deletedValue = _this.state.dataValue[index];

        if (typeof _this.props.deleteAction === 'function') {
          _this.props.deleteAction(deletedValue, index);
        }

        var deletedValues = [];

        if (deletedValue[_this.props.idField]) {
          deletedValues.push(_objectSpread2(_objectSpread2({}, deletedValue), {}, {
            _destroy: true
          }));
        }

        _this.doValueChange([].concat(_toConsumableArray(_this.state.dataValue.slice(0, index)), deletedValues, _toConsumableArray(_this.state.dataValue.slice(index + 1))));
      };
    });

    _defineProperty(_this, "add", function () {
      if (!_this.canAddRow()) {
        return;
      }

      var index = _this.state.dataValue.length;

      var newValue = _this.createNewValue(index);

      if (typeof _this.props.addAction === 'function') {
        _this.props.addAction(newValue, index);
      }

      _this.doValueChange([].concat(_toConsumableArray(_this.state.dataValue), [newValue]));
    });

    _defineProperty(_this, "createNewValue", function (index) {
      var newValue = _this.newValue(index);

      newValue._key = _this.nextKey++;
      return newValue;
    });

    _defineProperty(_this, "onValueChange", function () {
      return function (obj) {
        obj = Object.entries(obj).reduce(function (newObj, _ref) {
          var _ref2 = _slicedToArray(_ref, 2),
              key = _ref2[0],
              value = _ref2[1];

          set(newObj, key, value);
          return newObj;
        }, {});

        _this.doValueChange(deepmerge(_this.state.dataValue, obj[_this.props.name]));
      };
    });

    _defineProperty(_this, "doValueChange", function (dataValue) {
      _this.setState({
        dataValue: dataValue
      });

      var _this$props = _this.props,
          onValueChange = _this$props.onValueChange,
          onMultiValueChange = _this$props.onMultiValueChange;

      _this.callValueChange(dataValue, onValueChange);

      _this.callValueChange(dataValue, onMultiValueChange);
    });

    _defineProperty(_this, "callValueChange", function (dataValue, onValueChange) {
      var name = _this.props.name;

      if (typeof onValueChange === 'function') {
        if (name) {
          onValueChange(_defineProperty({}, name, dataValue));
        } else {
          onValueChange(dataValue);
        }
      }
    });

    _defineProperty(_this, "renderButton", function (props, index, key) {
      if (typeof props === 'function') {
        return _this.renderButton(props(index), index, key);
      }

      if (props && props.action) {
        // Object for simple button
        return /*#__PURE__*/React.createElement(Button, {
          variant: props.className || 'secondary',
          onClick: props.action,
          disabled: _this.props.disabled || props.disabled,
          key: key
        }, props.icon ? /*#__PURE__*/React.createElement(FAIcon, {
          icon: props.icon
        }) : null, props.label);
      } else {
        return null;
      }
    });

    _defineProperty(_this, "renderChild", function (index) {
      if (!_this.props.children) {
        return null;
      }

      return React.Children.map(_this.props.children, function (child) {
        if (!child) return null;
        var name;

        if (_this.props.name) {
          var namePrefix = "".concat(_this.props.name, "[").concat(index, "]");
          name = child.props.name;

          if (name) {
            name = "".concat(namePrefix, "[").concat(name, "]");
          } else {
            name = namePrefix;
          }
        }

        return /*#__PURE__*/React.cloneElement(child, {
          data: _this.props.data || _this.props.dataValue[index],
          extractedData: _this.props.dataValue ? _this.props.dataValue[index] : null,
          onValueChange: _this.onValueChange(index),
          valueChangeDelay: _this.props.valueChangeDelay,
          runValidation: _this.props.runValidation,
          scrollContainerId: _this.props.scrollContainerId,
          activeLanguage: _this.props.activeLanguage,
          languages: _this.props.languages,
          disabled: _this.props.disabled,
          name: name || child.props.name
        });
      }, _this);
    });

    _defineProperty(_this, "renderRow", function (value, index) {
      var child = _this.renderChild(index);

      if (typeof _this.props.rowWrapper === 'function') {
        child = _this.props.rowWrapper(child, value, index);
      }

      var rowButtons = _this.props.rowButtons || [];

      if (_this.props.hasDeleteButton) {
        rowButtons = [].concat(_toConsumableArray(rowButtons), [Object.assign({}, {
          label: i18n.t('Delete'),
          className: 'link btn-multi-delete',
          icon: 'trash'
        }, _this.props.deleteButton, {
          action: _this["delete"](index),
          disabled: !_this.canDeleteRow(index)
        })]);
      }

      rowButtons = rowButtons.map(function (rowButton, buttonIndex) {
        return _this.renderButton(rowButton, index, buttonIndex);
      });
      var key = value._key || index;
      return /*#__PURE__*/React.createElement(Row, {
        key: "r_".concat(key),
        rowClassName: _this.props.rowClassName,
        rowButtonsClassName: _this.props.rowButtonsClassName,
        rowButtons: rowButtons,
        disabled: _this.props.disabled
      }, child);
    });

    _this.state = {
      dataValue: []
    };
    _this.nextKey = 1;
    return _this;
  }

  _inherits(MultiRowFieldGroup, _React$Component);

  return _createClass(MultiRowFieldGroup, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.syncDataValue(this.props);
    }
  }, {
    key: "syncDataValue",
    value: function syncDataValue(props) {
      var dataValue = props.data ? get(props.data, props.name) : props.dataValue;
      var prevCount;

      if (!dataValue) {
        dataValue = [];
        prevCount = -1;
      } else {
        prevCount = dataValue.length;
      }

      while (dataValue.length < props.min) {
        dataValue.push(this.createNewValue(dataValue.length));
      }

      if (dataValue.length !== prevCount) {
        this.doValueChange(_toConsumableArray(dataValue));
      }

      this.nextKey = dataValue ? dataValue.length + 1 : 1;
      this.setState({
        dataValue: dataValue
      });
    }
  }, {
    key: "newValue",
    value: function newValue(index) {
      if (typeof this.props.newObject === 'function') {
        return this.props.newObject(index);
      } else if (this.props.newObject) {
        return cloneDeep(this.props.newObject);
      } else {
        return {};
      }
    }
  }, {
    key: "activeRows",
    get: function get() {
      return (this.state.dataValue || []).filter(function (row) {
        return !row._destroy;
      });
    }
  }, {
    key: "canAddRow",
    value: function canAddRow() {
      if (typeof this.props.canAdd === 'function' && !this.props.canAdd(this.activeRows.length)) {
        return false;
      }

      return this.props.max <= 0 || this.activeRows.length < this.props.max;
    }
  }, {
    key: "canDeleteRow",
    value: function canDeleteRow(index) {
      if (typeof this.props.canDelete === 'function' && !this.props.canDelete(this.state.dataValue[index], index)) {
        return false;
      }

      return this.activeRows.length > this.props.min;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/React.createElement("div", {
        className: this.props.className
      }, (this.state.dataValue || []).map(function (value, index) {
        if (value._destroy) {
          return null;
        }

        return _this2.renderRow(value, index);
      }), this.props.hasAddButton ? /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-12"
      }, this.renderButton(Object.assign({}, {
        label: i18n.t('Add'),
        className: 'secondary btn-addbutton',
        icon: 'plus'
      }, this.props.addButton, {
        action: this.add,
        disabled: !this.canAddRow()
      })))) : null);
    }
  }]);
}(React.Component);

_defineProperty(MultiRowFieldGroup, "propTypes", {
  name: PropTypes.string,
  idField: PropTypes.string,
  data: PropTypes.object,
  dataValue: PropTypes.array,
  children: PropTypes.any,
  className: PropTypes.string,
  runValidation: PropTypes.bool,
  onValueChange: PropTypes.func,
  onMultiValueChange: PropTypes.func,
  valueChangeDelay: PropTypes.number,
  scrollContainerId: PropTypes.string,
  hasDeleteButton: PropTypes.bool,
  hasAddButton: PropTypes.bool,
  deleteButton: PropTypes.object,
  addButton: PropTypes.object,
  rowWrapper: PropTypes.func,
  rowClassName: PropTypes.string,
  rowButtonsClassName: PropTypes.string,
  rowButtons: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object, PropTypes.func])),
  newObject: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  deleteAction: PropTypes.func,
  addAction: PropTypes.func,
  activeLanguage: PropTypes.object,
  languages: PropTypes.arrayOf(PropTypes.object),
  disabled: PropTypes.bool,
  min: PropTypes.number,
  max: PropTypes.number,
  canAdd: PropTypes.func,
  canDelete: PropTypes.func
});

_defineProperty(MultiRowFieldGroup, "defaultProps", {
  idField: 'id',
  min: 1,
  max: -1,
  hasDeleteButton: true,
  hasAddButton: true
});

MultiRowFieldGroup.displayName = "MultiRowFieldGroup";
export { MultiRowFieldGroup };